import $ from 'jquery'
import { breakpoints } from './_site'
import { create as createSlider } from './slider'
import config from '../store/_config'
import { axiosInstance as axios, handleAxiosErrors, imageBaseUrl } from '../_utils'
import { getEmptyImage } from '../../dashboard/_utils'
import { getProductURL } from '../selectors/defaultSelectors'

// const timeout = {};
export const getFilters = (ignore) => {
  var filters = {},
    $inputs = $('.filter-list__link--active')

  $inputs.each(function () {
    var $input = $(this),
      value = $input.data('filter'),
      key = $input.closest('.filter-list').data('key')
    // name = $input.siblings('.field__value').text();

    // ignore
    if (ignore.indexOf(key) != -1) return

    if (typeof filters[key] === 'undefined') {
      filters[key] = []
    }

    filters[key].push(value)
  })

  return filters
}
export const applyFiltersClasses = ($el) => {
  var filterClass = 'filter-list__link',
    filterClassActive = filterClass + '--active',
    $filterContainer = $el.closest('.filters'),
    $filters = $filterContainer.find('.' + filterClassActive)

  // normal filter
  if ($el.hasClass(filterClass)) {
    $el.toggleClass(filterClassActive)
  }
  // clear filter
  else if ($el.is('[data-clear-filter]')) {
    $filters.removeClass(filterClassActive)
  }
}
export const applyFilters = ($el, ignore) => {
  var pageURL = $('#filters').data('url'),
    data = {},
    $sort = $('#sort-dropdown'),
    $perPage = $('#display-dropdown'),
    $rangePrice = $('#range-price'),
    price,
    initialPrice

  ignore = ignore || []

  applyFiltersClasses($el)

  // price
  if ($rangePrice.length) {
    price = $rangePrice.val().split(',')
    initialPrice = $rangePrice.data('min') + ',' + $rangePrice.data('max')
  }

  // sort
  if ($sort.length) {
    data.sort = $sort.val().split(',')
  }

  // per-page
  if ($perPage.length) {
    data.display = $perPage.val().split(',')
  }

  // price
  if (ignore.indexOf('price') && price != initialPrice) {
    data.min = price[0]
    data.max = price[1]
  }

  // search
  // data.search = $('#search-form').val().split(','); // movile is #responsive-search-form

  // filters
  data.filters = getFilters(ignore)
  $.map(data.filters, function (val, key) {
    data[key] = val
  })
  delete data.filters

  // convert to string
  $.map(data, function (val, i) {
    // replace ,
    data[i] = val.toString()

    // remove empty values
    if (!data[i]) {
      delete data[i]
    }
  })

  // convert to url format
  data = $.param(data)

  // fuck standards
  data = data.replace(/=/g, '/')
  data = data.replace(/&/g, '/')
  data = data.replace(/%2C/g, '~')
  data = data.replace(/%2F/g, '~~')

  console.log(data)

  window.location.href = pageURL + data
}
export const convertProductsListingToASimplifiedFormat = (list) => {
  let newList = []
  list.map((item) => {
    const ProductVariationID = item._id
    const { RLink, ListImg, Title } = item._source

    let data = {
      // ProductVariationID
      id: ProductVariationID,
      url_slug: RLink,
      image: ListImg || getEmptyImage(),
      title: Title,
    }

    newList.push(data)
  })

  return newList
}
export const toggleSliderLoading = ($el, flag) => {
  if (flag) {
    $el.addClass('product-slider--loading')
  } else {
    $el.removeClass('product-slider--loading')
  }
}
export const renderSliderItems = (list) => {
  let html = ''

  list.map((item) => {
    const { title, image, url_slug } = item

    html += `
        <div class="product-grid__item slider__item">
            <a href="${getProductURL(url_slug)}" class=" product-grid__link" title="${title}">
                <figure class="photo photo--center product-grid__photo">
                    <img src="${image && image?.includes(`${imageBaseUrl}`) ? image : imageBaseUrl + image}" alt="" />
                </figure>
                <div class="product-grid__content">
                    <span class="product-grid__title">${title}</span>
                </div>
            </a>
        </div>`
  })

  return html
}
export const requestRelatedProducts = ($el) => {
  if (!(typeof $el != 'undefined' && $el.length)) {
    return
  }

  let style = $el.data('style'),
    varietal = $el.data('varietals'),
    type = $el.data('type'),
    productID = $el.data('pid'),
    $sliderCycle = $el.find('.slider__cycle')

  let { url } = config.products.replacements

  url = url
    .replace(/{style}/, style)
    .replace(/{varietal}/, varietal)
    .replace(/{type}/, type)
    .replace(/{productid}/, productID)
    .replace(/{limit}/, 12)

  toggleSliderLoading($el, true)

  return axios
    .get(url, {
      // withCredentials: true,
    })
    .then((response) => {
      // render
      const products = convertProductsListingToASimplifiedFormat(response.data.hits.hits)
      if (products.length) {
        $sliderCycle.html(renderSliderItems(products))
      } else {
        let $tab = $el.closest('.tab-pane'),
          $section = $el.closest('.related-products')

        if ($tab.length) {
          // Remove tab
          $('#related-0').remove()
          $('[data-target="#related-0"]').remove()

          //
          let $tabLinks = $section.find('.related-tabs-nav__link').not('[data-target="#related-0"]')
          if ($tabLinks.length) {
            $tabLinks.first().tab('active')
          } else {
            $section.remove()
          }
        } else {
          $section.remove()
        }
      }

      // generate slider
      createProductSlider($el)

      toggleSliderLoading($el, false)
    })
    .catch((error) => handleAxiosErrors(error))
}
export const createProductSlider = ($el) => {
  createSlider($el, {
    fade: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      // {
      //     breakpoint: site.breakpoints.xl,
      //     settings: {
      //         slidesToShow: 4,
      //         slidesToScroll: 4,
      //     }
      // },
      {
        breakpoint: breakpoints.lg,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: breakpoints.md,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: breakpoints.sm,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: breakpoints.xs,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  })
}
export const binds = ($el, ignore) => {
  // products
  // createProductSlider($('.products-slider'));
  requestRelatedProducts($('.products-slider'))

  // ---------------- change filter
  $('button[data-filter]').on('click.products', function () {
    applyFilters($(this))
  })
  $('select[data-filter]').on('change.products', function () {
    applyFilters($(this))
  })
  $('[data-clear-filter]').on('click.products', function () {
    applyFilters($(this), [$(this).data('clear-filter')])
  })
  $('#price-range').on('submit', function (event) {
    event.preventDefault()
    applyFilters($(this))
  })
}
